import { render } from "./Thanks.vue?vue&type=template&id=17f5bd08&bindings={\"state\":\"props\",\"prevPage\":\"setup\"}"
import script from "./Thanks.vue?vue&type=script&lang=ts"
export * from "./Thanks.vue?vue&type=script&lang=ts"

import "./Thanks.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script